import { Box, BoxProps, ButtonNew } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/core'
import { useCallback, useEffect, useState } from 'react'
import * as React from 'react'
import { AllEMIPlans } from '..'
import { EMIType } from '../../../data/models/EMI'
import { useLazyApiData, useStores } from '../../../data/store'
import { Header } from '../../../nav/PayStack'
import { formatAmount, getCardVendor, isIFrame } from '../../../utils'
import { HEADER, windowConfig } from '../../../utils/constants'
import { MobileProcessing } from '../../PaymentProcesseing/MobileProcessing'
import { CardEMIPlans } from '../CardEMIPlans'
import { SavedCardEmiList } from './SavedCardEmiList'
import { TopAddNewContainer } from './TopAddNewContainer'

interface SavedCardProps {
  isJioFinHubDesign: boolean
  type: string
  onCvvAndPlanSelected: any
}

export const SavedCard = ({ isJioFinHubDesign, type, onCvvAndPlanSelected }: SavedCardProps) => {
  const navigation = useNavigation()
  const route: any = useRoute()
  const { theme, savedCard, getAllEMIListForSavedCard, addPaymentMethod, uniqueWindowId } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
    savedCard: root?.user?.paymentMethod,
    getAllEMIListForSavedCard: root?.getAllEMIListForSavedCard,
    addPaymentMethod: root.transaction.addPaymentMethod,
    uniqueWindowId: root.config.uniqueWindowId,
  }))
  const CARD_TYPE = route?.params?.type ?? type
  const { REACT_APP_ENDPOINT = '', REACT_APP_URL = '' } = process.env
  const [allEMIPlansOpen, setAllEmiPlansOpen] = useState(false)
  const [selectedEmiPlan, setSelectedEmiPlan] = useState<any>(null)
  const [showPericulerEmiPlans, setShowPericulerEmiPlans] = useState(false)
  const [selectedCardCvv, setSelectedCardCvv] = useState('')
  const [getAllEMIListForSavedCardAsync, getAllEMIListForSavedCardHandler] = useLazyApiData(getAllEMIListForSavedCard)
  const [selectedCard, setSelectedCard] = useState<any>(null)
  const cardList = savedCard?.filter((card: any) => card?.type === CARD_TYPE)
  const [showPaymentProcessModal, setShowPaymentProcessModal] = useState(false)
  const [selectedCardIndex, setSelectedCardIndex] = React.useState(-1)

  const onSelectedCardChange = (cardIndex: number) => {
    setSelectedCardCvv('')
    setSelectedEmiPlan(null)
    setSelectedCardIndex(cardIndex)
  }

  const onSelectEmiPlanPress = (card: any) => {
    setSelectedCard(card)
    getAllEMIListForSavedCardAsync(card?.token, card.type === 'CREDITCARD' ? '00' : '01')
  }

  useEffect(() => {
    if (getAllEMIListForSavedCardHandler.state === 'fulfilled') {
      setSelectedCard({ ...selectedCard, cardBin: getAllEMIListForSavedCardHandler?.data?.cardBin })
      setShowPericulerEmiPlans(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAllEMIListForSavedCardHandler.state])

  const loadProcessingScreen = useCallback(() => {
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`

    if (!isIFrame()) {
      window.currentChild = window
    } else {
      window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
      window.currentChild?.focus()
    }
    setShowPaymentProcessModal(true)
  }, [REACT_APP_ENDPOINT, REACT_APP_URL, uniqueWindowId])

  const getConfirmRequest = useCallback(() => {
    return {
      bank: selectedEmiPlan?.bank,
      tenure: selectedEmiPlan?.tenure,
      scheme: selectedEmiPlan?.scheme,
      value: selectedEmiPlan?.value,
      interestRate: selectedEmiPlan?.interestRate,
      processingFee: selectedEmiPlan?.processingFee,
      processingFeeTax: selectedEmiPlan?.processingFeeTax,
      convenienceFee: selectedEmiPlan?.convenienceFee,
      convenienceFeeTax: selectedEmiPlan?.convenienceFeeTax,
      cashBack: selectedEmiPlan?.cashBack,
      card: {
        number: selectedCard?.number,
        type: selectedCard?.type,
        cvv: String(selectedCardCvv),
        subType: selectedCard?.subType.toString(),
        ownerName: selectedCard?.ownerName,
        expmon: Number(selectedCard?.expmon),
        expyr: Number(selectedCard?.expyr),
        expDate: selectedCard?.expDate,
        id: 0,
        scheme: selectedCard?.scheme,
        isSave: selectedCard?.isSave,
        token: selectedCard?.token,
      },
      paymentType: 'EMI',
    } as EMIType
  }, [selectedCard, selectedCardCvv, selectedEmiPlan])
  const maxCvvLength = getCardVendor(cardList[selectedCardIndex]?.scheme) === 'amex' ? 4 : 3
  useEffect(() => {
    const newEMI = getConfirmRequest() as any
    if ((cardList[selectedCardIndex] as any)?.isCvvLess) {
      onCvvAndPlanSelected?.(!!selectedEmiPlan ? newEMI : {})
    } else {
      onCvvAndPlanSelected?.(selectedCardCvv?.length === maxCvvLength && !!selectedEmiPlan ? newEMI : {})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCardCvv, selectedEmiPlan,selectedCardIndex])

  const onPayButtonClick = () => {
    const newEMI = getConfirmRequest() as any
    addPaymentMethod(newEMI)
    loadProcessingScreen()
  }

  return (
    <Box {...styles.container(isJioFinHubDesign)} backgroundColor={theme?.bodyBgColor}>
      {!isJioFinHubDesign && (
        <Header
          title={CARD_TYPE === 'CREDITCARD' ? HEADER.emicard : HEADER.emicardDc}
          rightTitle={'View all EMI Plans'}
          onGoBack={() => navigation?.goBack()}
          theme={theme}
          onClickRightHeader={() => setAllEmiPlansOpen(true)}
        />
      )}
      <>
        {!isJioFinHubDesign && (
          <TopAddNewContainer type={CARD_TYPE} theme={theme} totalAvaliableCard={cardList?.length} />
        )}
        <SavedCardEmiList
          {...{
            onSelectEmiPlanPress,
            cardList,
            theme,
            isLoading: getAllEMIListForSavedCardHandler.state === 'pending',
            buttonText: !selectedEmiPlan
              ? 'Select a EMI Plan'
              : `₹${selectedEmiPlan?.emi} X ${selectedEmiPlan?.tenure} | ${selectedEmiPlan?.interestRate}% p.a`,
            cvv: selectedCardCvv,
            onCvvChange: (cvv) => {
              setSelectedCardCvv(cvv)
            },
            selectedCardIndex,
            setSelectedCardIndex: onSelectedCardChange,
          }}
        />
        {allEMIPlansOpen && <AllEMIPlans open={allEMIPlansOpen} setOpen={setAllEmiPlansOpen} />}
        {showPericulerEmiPlans && (
          <CardEMIPlans
            theme={theme}
            cardNo={selectedCard.cardBin}
            schemeSubType={selectedCard.type === 'CREDITCARD' ? '00' : '01'} //THAG TODO 00 CC 01 DC(NEED TO CHECK  )
            onEMIPlanSelected={(item: any, isValidOffer: boolean) => {
              //const isNewCard = postDataRef?.current.isNewCard
              console.log('{ item, isValidOffer }', { item, isValidOffer })
              setSelectedEmiPlan({ ...item, isValidOffer })
            }}
            onDismiss={() => {
              setShowPericulerEmiPlans(false)
            }}
          />
        )}
      </>
      {!!selectedCardCvv && !!selectedEmiPlan && !isJioFinHubDesign && (
        <Box backgroundColor={theme?.bodyBgColor} width={'100%'} p={24}>
          <ButtonNew
            title={`Pay ₹${formatAmount(String(selectedEmiPlan?.totalAmount))} through EMI`}
            icon="LOCK"
            onPress={onPayButtonClick}
            color={theme?.brandColor}
            titleColor={theme?.headingText}
            underlayColor={theme?.brandColor}
            hoverColor={theme?.brandColor}
          />
        </Box>
      )}
      {showPaymentProcessModal && (
        <MobileProcessing setShow={setShowPaymentProcessModal} show={showPaymentProcessModal} />
      )}
    </Box>
  )
}

const styles = {
  container: (isJioFinHubDesign: boolean) =>
    ({
      flex: !isJioFinHubDesign ? 1 : undefined,
      overflowY: !isJioFinHubDesign ? 'scroll' : 'auto',
    } as BoxProps),
}
